import { mapDTO } from '@twistezo/ts-dto-mapper'

import { floatPercentToDTO } from 'utils/number'
import { Schema } from '../../schema'
import { Variables } from './types'

type From = Schema

type To = Variables

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((from: From): To => {
    const { id, refresherEnabled, refreshRedirect } = from
    const { sendRefreshRequestToExternalAdUnitEnabled, targetAdUnitPath } = refreshRedirect

    const {
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold,
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval,
      mobileAdThreshold,
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval,
    } = from.basicSettings

    return {
      adUnitId: id,
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold: floatPercentToDTO(desktopAdThreshold),
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval: desktopRefreshInterval * 1000,
      mobileAdThreshold: floatPercentToDTO(mobileAdThreshold),
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval: mobileRefreshInterval * 1000,
      refresherEnabled,
      sendRefreshRequestToExternalAdUnitEnabled,
      ...(sendRefreshRequestToExternalAdUnitEnabled
        ? { externalAdUnitPath: targetAdUnitPath }
        : {}),
    }
  })
